import { CodeCanvasModel } from "./code-canvas";

export default CodeCanvasModel.extend({
  constructor(attr, options) {
    attr = attr || {};
    return CodeCanvasModel.prototype.constructor.call(this, attr, options);
  },
});
